<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Push') != -1" type="primary" class="btn primary" @click="push">确认上传</el-button>
          <!-- && !system_setting.isAutoSubmitOrderToPriceMonitor -->
          <el-button v-if="tableAcl.indexOf('Push') != -1" type="primary" class="btn primary" @click="pull">获取配送</el-button>

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-button type="primary" class="btn primary" @click="updateOrderState">重置状态</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
      </div>

      <!-- row-key="id" -->
      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" :span-method="objectSpanMethod" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <!-- :reserve-selection="true" -->
        <el-table-column fixed prop="selection" type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="priceMonitorHospitalId" width="120" label="医院编号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorHospitalId?scope.row.priceMonitorHospitalId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="no" width="170" label="医院采购订单号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorOrderName" width="150" label="平台订单名称" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorOrderName?scope.row.priceMonitorOrderName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorOrderTypeName" width="120" label="平台订单类型" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorOrderTypeName?scope.row.priceMonitorOrderTypeName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorDefaultDistributeAddr" width="120" label="配送地址" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorDefaultDistributeAddr?scope.row.priceMonitorDefaultDistributeAddr:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorCreatedTime" width="150" label="平台订单提交时间" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorCreatedTime?parseTime(new Date(scope.row.priceMonitorCreatedTime)):'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" width="150" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.createdTime))
          }}</template>
        </el-table-column>
        <el-table-column prop="createdUserName" width="80" label="创建人" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createdUserName?scope.row.createdUserName:'-' }}
          </template>
        </el-table-column>

        <el-table-column prop="detailId" width="140" show-overflow-tooltip label="医院订单明细编号"></el-table-column>
        <el-table-column prop="supplierProductNo" width="140" show-overflow-tooltip label="院目录编码"></el-table-column>
        <el-table-column prop="productName" width="120" label="院产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specName" width="120" label="院规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="newProductId" width="120" label="院供货产品id" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productCode" width="120" label="院商品代码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerName" width="120" label="院生产厂商" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsId" width="120" label="平台产品ID" show-overflow-tooltip></el-table-column>
        <el-table-column prop="price" width="100" label="院采购价" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lowInPrice" width="120" label="平台最低价"></el-table-column>
        <!-- <el-table-column prop="priceMonitorMinPrice" width="100" label="平台最低价" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorMaxPrice" width="120" label="平台最高价"></el-table-column> -->
        <el-table-column prop="minUnit" width="100" label="院最小单位" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderNumber" width="120" label="院采购数量"></el-table-column>
        <el-table-column prop="amount" width="100" label="金额" show-overflow-tooltip></el-table-column>
        <el-table-column prop="priceMonitorCompanyIdPs" width="100" label="配送商编码" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorCompanyIdPs?scope.row.priceMonitorCompanyIdPs:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" width="100" label="配送商名称" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.supplierName?scope.row.supplierName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="isDistributionName" width="80" label="是否集采" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailRemark" width="100" label="订单备注" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.detailRemark?scope.row.detailRemark:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorConfirmTime" width="120" label="平台响应时间" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorConfirmTime?parseTime(new Date(scope.row.priceMonitorConfirmTime)):'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorOrderDetailStateName" width="120" label="平台订单状态" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorOrderDetailStateName?scope.row.priceMonitorOrderDetailStateName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorRefuseReason" width="100" label="拒绝理由" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorRefuseReason?scope.row.priceMonitorRefuseReason:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorDetailId" width="140" label="平台订单明细编号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorDetailId?scope.row.priceMonitorDetailId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorDetailPushStateName" width="100" label="数据状态" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierProductCompareStateName" width="100" label="对照状态" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" prop="priceStateName" width="100" label="价格状态" show-overflow-tooltip>
          <template slot-scope="scope"><span :class="{
                enable: scope.row.priceState == 1,
                forbidden: scope.row.priceState == 0,
              }">{{ scope.row.priceStateName }}</span></template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetPurchaseOrderDetails,
  ValidateOrderDetail,
  PushPurchaseOrderToProduct,
  GetDistributesByOrderDetailId,
  ExportPriceMonitorOrder,
  UpdatePriceMonitorOrderState,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  PriceMonitorOrderTypeOptions,
  PriceMonitorPushStateOptions,
  PriceMonitorCompareStateOptions,
  PriceMonitorPriceStateOptions,
  PriceMonitorOrderStateOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      exportAction: ExportPriceMonitorOrder,
      GetDatasAction: GetPurchaseOrderDetails,

      PriceMonitorOrderTypeOptions: PriceMonitorOrderTypeOptions,
      PriceMonitorPriceStateOptions: PriceMonitorPriceStateOptions,
      PriceMonitorCompareStateOptions: PriceMonitorCompareStateOptions,
      PriceMonitorPushStateOptions: PriceMonitorPushStateOptions,
      PriceMonitorOrderStateOptions: PriceMonitorOrderStateOptions,
      filterOptions: [
        {
          name: "医院采购订单号",
          type: "input",
          code: "hospitalOrderNo",
        },
        {
          name: "平台订单名称",
          type: "input",
          code: "priceMonitorName",
        },
        {
          name: "订单类型",
          type: "select",
          code: "orderType",
          data: PriceMonitorOrderTypeOptions,
        },
        {
          name: "数据状态",
          type: "select",
          code: "state",
          data: PriceMonitorPushStateOptions,
        },
        {
          name: "创建时间",
          type: "date",
          code: "date",
          defaultValue: this.getDefaultDateRange(), // [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],//],
          startDateCode: "startDate",
          endDateCode: "endDate",
        },
        {
          name: "创建人",
          type: "select",
          code: "createdUser",
          filterMethod: this.getUsers,
          data: [],
        },
        {
          name: "平台产品ID",
          type: "input",
          code: "goodsId",
        },
        {
          name: "院目录编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "院规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "院生产厂商",
          type: "input",
          code: "manufacturerName",
        },
        {
          name: "院采购价",
          type: "number",
          code: "price",
        },
        {
          name: "配送企业编码",
          type: "input",
          code: "companyIdPs",
        },
        {
          name: "配送企业名称",
          type: "input",
          code: "companyName",
        },
        {
          name: "平台订单状态",
          type: "select",
          code: "orderDetailState",
          data: PriceMonitorOrderStateOptions,
        },
        // {
        //   name: "价格状态",
        //   type: "select",
        //   code: "priceState",
        //   data: PriceMonitorPriceStateOptions
        // },
        {
          name: "目录对照状态",
          type: "select",
          code: "supplierProductCompareState",
          data: PriceMonitorCompareStateOptions,
          defaultValue: 1,
        },
        {
          name: "订单备注",
          type: "input",
          code: "remark",
        },
      ],
      spanArr: [],
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      // orderDetailIds
      priceMonitorDetailIds: [],
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.priceMonitorDetailIds = selection.map((item) => item.priceMonitorDetailId);
      this.multiple = !selection.length;
      console.log("selection", selection);
    },
    // 获取列表
    getData () {
      console.log(this.system_setting);
      this.loading = true;
      this.GetDatasAction(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;

          this.getSpanArr(this.tableData);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        priceMonitorType: 0,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    getDefaultDateRange () {
      var endDate = new Date();
      var start = new Date(new Date().setDate(new Date().getDate() - 6));
      // 开始日期转换为00:00:00
      var startDate = new Date(
        `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()} 00:00:00`
      );

      return [startDate, endDate];
    },
    getSpanArr (data) {
      this.spanArr = [];
      if (!data) {
        return;
      }
      // data就是我们从后台拿到的数据
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].no === data[i - 1].no) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        // console.log(this.spanArr);
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log(column)
      var colNames = [
        "selection",
        "no",
        "priceMonitorHospitalId",
        "priceMonitorOrderName",
        "priceMonitorOrderTypeName",
        "priceMonitorDefaultDistributeAddr",
        "priceMonitorCreatedTime",
        "createdTime",
        "createdUserName",
      ];
      // if (column.property == 'no') { // || column.property == "printingTimes"
      if (colNames.indexOf(column.property) != -1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        // console.log(`rowspan:${_row} colspan:${_col}`);
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    pull () {
      if (!this.ids || this.ids.length == 0) {
        this.$my_message("请选择要获取的订单配送数据", "warning");
        return;
      }
      var pushedList = this.multipleSelection.filter((e) => e.priceMonitorState == 0);
      if (pushedList && pushedList.length > 0) {
        this.$my_message("请选择已上传的订单数据", "warning");
        return;
      }
      if (this.ids.length > 10) {
        this.$my_message("一次最大获取10条配送信息", "warning");
        return;
      }
      var orderDetailStates = this.multipleSelection.filter(
        (e) => [4, 7, 8].indexOf(e.priceMonitorOrderDetailState) == -1
      );
      // filter(e => !(e.priceMonitorOrderDetailState == 4 || e.priceMonitorOrderDetailState == 7 || e.priceMonitorOrderDetailState == 8))
      if (orderDetailStates && orderDetailStates.length > 0) {
        this.$my_message("请选择已配送待收货|收货中|已收货的数据", "warning");
        return;
      }

      GetDistributesByOrderDetailId(this.priceMonitorDetailIds).then((res) => {
        if (res.successful) {
          this.$my_message(`提交成功`, "success");
        }
      });
    },

    push () {
      if (!this.ids || this.ids.length == 0) {
        this.$my_message("请选择要上传的订单数据", "warning");
        return;
      }

      var pushedList = this.multipleSelection.filter(
        (e) => e.priceMonitorDetailState == 1
      );
      if (pushedList && pushedList.length > 0) {
        this.$my_message("请选择未上传的订单数据", "warning");
        return;
      }

      ValidateOrderDetail({ ids: this.ids }).then((res) => {
        if (res.returnData) {
          var exceptionList = res.returnData.exceptionList;
          var notFinishCompareList = res.returnData.notFinishCompareList;
          // 提示
          if (exceptionList.length > 0 || notFinishCompareList.length > 0) {
            const h = this.$createElement;
            let content = [h("p", "所选医院采购订单存在以下异常：")];
            if (exceptionList.length > 0) {
              // content = [h('p', '以下所选医院采购订单存在价格异常：')]
              exceptionList.forEach((item) => {
                content.push(
                  h("p", { style: "color:red" }, `订单号：${item}存在价格异常`)
                );
              });
            }
            if (notFinishCompareList.length > 0) {
              // content = [h('p', '以下所选医院采购订单存在未对照的目录：')]
              notFinishCompareList.forEach((item) => {
                content.push(
                  h("p", { style: "color:red" }, `订单号：${item}存在未对照的目录`)
                );
              });
            }

            content.push(h("p", "确定要继续上传吗？"));

            this.$confirm("提示", {
              title: "提示",
              type: "warning",
              message: h("div", content),
            }).then(() => {
              // 上传订单
              this.pushOrder();
            });
          } else {
            this.pushOrder();
          }
        } else {
          // 上传订单
          this.pushOrder();
        }
      });
    },
    pushOrder () {
      PushPurchaseOrderToProduct({ ids: this.ids }).then((res) => {
        this.$my_message("上传成功", "success");

        this.$refs.multipleTable.clearSelection();
        this.getData();
        // this.reset();
      });
    },

    updateOrderState () {
      if (!this.ids || this.ids.length == 0) {
        this.$my_message("请选择要重置状态的订单数据", "warning");
        return;
      }

      // var notPushedList = this.multipleSelection.filter(e => e.priceMonitorDetailState != 1)
      // if (notpushedList && notPushedList.length > 0) {
      //   this.$my_message('请选择已上传的订单数据', 'warning');
      //   return;
      // }
      this.$my_confirm("此操作将重置所选订单的上传状态，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return UpdatePriceMonitorOrderState({ ids: this.ids });
        })
        .then((res) => {
          this.$my_message("重置成功", "success");
          this.getData();
        });
    },
  },
  mounted () {
    // this.$set(this.$refs["selectFilter"].query, "category", 0)
    // this.$set(this.$refs["selectFilter"].query, "categoryName", '普通')
    // // this.$refs["selectFilter"].query.category = 0
    // // this.$refs["selectFilter"].query.categoryName = '普通'
    // if (this.$route.params) {
    //   this.$refs["selectFilter"].query.category = ''
    // }
    this.getData();
  },
  created () {
    // // this.query.category = 0
    // this.$set(this.query, "category", 0)
    // if (this.$route.params && this.$route.params.startDate) {
    var dateArr = this.getDefaultDateRange();
    this.query.startDate = this.parseTime(dateArr[0]);
    this.query.endDate = this.parseTime(dateArr[1]);
    //   this.query.category = ''
    //   // this.$set(this.query, "category", "")
    // }
    this.query.priceMonitorType = 0;
  },
};
</script>

<style lang="scss" scoped></style>
